<section class="results">
  <h2>Resultados de tu búsqueda</h2>

  <ng-container *ngIf="(breakpoint$ | async).matches; else mobileResults">
    <div class="resultsInfo">
      <div class="resultsInfo_item">Descripción del producto</div>
      <div class="resultsInfo_item">N° Orden</div>
      <div class="resultsInfo_item">Total a Pagar</div>
      <div class="resultsInfo_item">Método de pago</div>
      <ng-container *ngFor="let row of dataResult.body">
        <div class="descs" *ngIf="row.columns[0].text">
          <div [innerHTML]="row.columns[0].text" class="desc_item">
          </div>
        </div>
        <div class="center_end">#{{row.columns[1].code}}</div>
        <div class="center_end">
          <div>
            <strong>{{row.columns[2].value}}</strong>
            <div *ngIf="row.columns[2].tax">{{row.columns[0].tax}} incluido</div>
          </div>
        </div>
        <ng-container [ngSwitch]="linkType">
          <div *ngSwitchCase="'both'" class="center_end">
              <button
              class="resultsBtn"
              *ngIf="row.columns[3].buttonDebit"
              (click)="navigateTo(row.columns[3].buttonDebit.href)">
              DÉBITO O CRÉDITO</button>
              <button
              class="resultsBtn"
              *ngIf="row.columns[3].buttonTransfer"
              (click)="navigateTo(row.columns[3].buttonTransfer.href)">
              TRANSFERENCIA</button>
          </div>
          <div *ngSwitchCase="'single'" class="center_end">
            <button
              class="resultsBtn"
              *ngIf="row.columns[3].buttonPaymentOthers"
              (click)="navigateTo(row.columns[3].buttonPaymentOthers.href)"
            >
              VER ORDEN
            </button>
          </div>
          <div *ngSwitchCase="'none'">
            <p *ngIf="row.columns[3].buttonPaymentOthers || row.columns[3].buttonDebit || row.columns[3].buttonTransfer">
              Lo sentimos, no se ha encontrado un link de pago
            </p>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #mobileResults>
    <div class="resultsInfoMobile">
      <div *ngFor="let row of dataResult.body" class="resultItem">
        <div>
          <div class="resultsInfo_item">Descripción del producto</div>
          <div class="descs" *ngIf="row.columns[0].text">
            <div [innerHTML]="row.columns[0].text" class="desc_item">
            </div>
          </div>
        </div>

        <div>
          <div class="resultsInfo_item">N° Orden</div>
          <div>#{{ row.columns[1].code}}</div>
        </div>

        <div>
          <div class="resultsInfo_item">Total a Pagar</div>
          <div>
            <div>
              <strong>{{row.columns[2].value}}</strong>
              <div *ngIf="row.columns[2].tax">{{row.columns[0].tax}} incluido</div>
            </div>
          </div>
        </div>
        <div>
          <div class="resultsInfo_item">Método de pago</div>
          <div class="resultButtons">
            <ng-container [ngSwitch]="linkType" class="center_end">
              <div *ngSwitchCase="'both'" class="resultButtons">
                <button
                class="resultsBtn"
                *ngIf="row.columns[3].buttonDebit"
                (click)="navigateTo(col.buttonDebit.href)">
                DÉBITO O CRÉDITO</button>
                <button 
                class="resultsBtn"
                *ngIf="row.columns[3].buttonTransfer" 
                (click)="navigateTo(row.columns[0].buttonTransfer.href)">
                TRANSFERENCIA</button>
              </div>
              <div *ngSwitchCase="'single'" class="resultButtons">
                <button 
                  class="resultsBtn"
                  *ngIf="row.columns[3].buttonPaymentOthers"
                  (click)="navigateTo(row.columns[3].buttonPaymentOthers.href)"
                >
                  VER ORDEN
                </button>
              </div>
              <div *ngSwitchCase="'none'">
                <p *ngIf="row.columns[3].buttonPaymentOthers || row.columns[3].buttonDebit || row.columns[3].buttonTransfer">
                  Lo sentimos, no se ha encontrado un link de pago
                </p>
              </div>    
            </ng-container>  
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="alert" *ngIf="showAlertMessage">
    <img src="/assets/icons/exclamation.svg" alt="Aviso: solo órdenes impagas de servicios ya terminados">
    <div>
      Lo sentimos! sólo encontramos ordenes impagas de servicios que ya están
      terminados, si gustas puedes contratar un nuevo producto o servicio.
    </div>
  </div>

</section>
